import React from 'react';
import '../Styles/styles.css';
import { Link } from 'react-router-dom';

const Product = () => {
    return (
        <section id="product" className="services bg-white">
            <div className="container" data-aos="fade-up">

                <div className="section-title">
                    <h2>Product</h2>
                </div>

                <div className="row">
                    <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                        <div className="icon-box shadow-lg d-flex flex-column h-100 p-3">
                            <Link to='/edict' className='text-decoration-none text-black'>
                                <h4 className='text-center'><a href="#" className='text-decoration-none Sign-in'>EDICT</a></h4>
                                <p>
                                    EDICT enables implementation of digital offices covering compound documents
                                    management, input-output registers, email integration, moving office documents
                                    across work centers.
                                </p>
                            </Link>
                            <div className="mt-auto">
                                <a href="#" className="text-decoration-none sign-in">
                                    Sign In <i className="bi bi-arrow-right"></i>
                                </a>
                            </div>
                        </div>

                    </div>

                    <div className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay="200">
                        <div className="icon-box shadow-lg d-flex flex-column h-100 p-3">
                            <Link to='/traceGRC' className='text-decoration-none text-black'>
                                <h4 className='text-center'>
                                    <a className='text-decoration-none sign-in'>
                                        TRACe GRC
                                    </a>
                                </h4>
                                <p>
                                    TRACe covers the complete life cycle of Risk, Audit, and Compliance activities,
                                    which addresses the vertical segment of Audit professionals.
                                </p>
                            </Link>
                            <div className="mt-auto">
                                <a href="https://www.tracelite.multimedia.interactivedns.com/" className="text-decoration-none sign-in">
                                    Sign In <i className="bi bi-arrow-right"></i>
                                </a>
                            </div>
                        </div>

                    </div>

                    <div className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0" data-aos="zoom-in" data-aos-delay="300">
                        <div className="icon-box shadow-lg d-flex flex-column h-100 p-3">
                            <Link to='/clact' className='text-decoration-none text-black'>
                                <h4 className='text-center'><a className='text-decoration-none sign-in'>CLACT</a></h4>
                                <p>
                                    CLACT addresses all standard accounting requirements and facilitate compilation of
                                    balance sheets, P & L accounts and statutory returns.
                                </p>
                            </Link>
                            <div className="mt-auto">
                                <a className="text-decoration-none sign-in">
                                    Sign In <i className="bi bi-arrow-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0" data-aos="zoom-in" data-aos-delay="400">
                        <div className="icon-box shadow-lg d-flex flex-column h-100 p-3">
                            <Link to='/docAssist-product' className='text-decoration-none text-black'>
                                <h4 className='text-center'><a className='text-decoration-none sign-in'>Doc Assist</a></h4>
                                <p>
                                    Doc Assist is a software products targeted at the medical profession very often deal
                                    with aspects such as billing, hospital bed management, inventories.
                                </p>
                            </Link>
                            <div className="mt-auto">
                                <a className="text-decoration-none Sign-in">
                                    Sign In <i className="bi bi-arrow-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Product